import { useEffect, useRef, useState } from "react";
import { PREVIEW_PAGE_HEIGHT_PX } from "../constants/templateEditorConstants";
import "./_template-preview-frame.scss";

/**
 * Preview is rendered at exactly one PDF page wide and auto-grows in height so
 * multi-page templates stay fully visible instead of being clipped.
 */
const TemplatePreviewFrame = ({ srcDoc, orientation }) => {
  const frameRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);
  const minHeight =
    PREVIEW_PAGE_HEIGHT_PX[orientation] || PREVIEW_PAGE_HEIGHT_PX.portrait;

  useEffect(() => {
    const frame = frameRef.current;
    if (!frame) return undefined;

    let raf = null;
    // Reset so a shorter document can shrink back to a single page
    setContentHeight(0);

    const measure = () => {
      try {
        const doc = frame.contentDocument;
        const height =
          doc?.documentElement?.scrollHeight || doc?.body?.scrollHeight || 0;
        setContentHeight(height ? Math.ceil(height) : 0);
      } catch (_e) {
        // cross-origin preview (backend render) — keep the single-page height
      }
    };

    const onLoad = () => {
      measure();
      raf = requestAnimationFrame(measure);
    };

    frame.addEventListener("load", onLoad);
    measure();

    return () => {
      frame.removeEventListener("load", onLoad);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [srcDoc]);

  const height = Math.max(contentHeight, minHeight);

  return (
    <div
      className="template-preview-frame"
      style={{ "--template-preview-frame-height": `${height}px` }}
    >
      <iframe
        ref={frameRef}
        title="Template live preview"
        srcDoc={srcDoc}
        className="template-preview-frame__iframe"
      />
    </div>
  );
};

export default TemplatePreviewFrame;
